import { useCancelPolicyOfHotelPolicy } from "./hooks/use-cancel-policy/use-cancel-policy";
import { QuestionCancelPolicy } from "../../../../../../../../_shared/ui/components/main/questions/cancel-policy";

export const QuestionHotelPolicyCancelPolicy = () => {
	const {
		cancelPolicy,
		append,
		removeCancelPolicyByIndex,
		beforeDaysOptions,
		updateBeforeDays,
		chargeRatioOptions,
		updateChargeRatio,
	} = useCancelPolicyOfHotelPolicy();

	const guide = `プラン、部屋、オプションで、個別にキャンセルポリシーが設定されていない場合このポリシーが適用されます。<br />
こちらのキャンセルポリシーを設定されていない場合、すべてのキャンセルが無料になります。`;

	return (
		<QuestionCancelPolicy
			cancelPolicy={cancelPolicy}
			appendCancelPolicy={append}
			removeCancelPolicy={removeCancelPolicyByIndex}
			cancelPolicyBeforeDaysOptions={beforeDaysOptions}
			changeCancelPolicyBeforeDays={updateBeforeDays}
			cancelPolicyChargeRatioOptions={chargeRatioOptions}
			changeCancelPolicyChargeRatio={updateChargeRatio}
			hasError={cancelPolicy?.hasError}
			isEdited={cancelPolicy?.isEdited}
			guide={guide}
		/>
	);
};

QuestionHotelPolicyCancelPolicy.displayName = "QuestionHotelPolicyCancelPolicy";
